/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateTeamsVerificationKeyInput = {|
  tenant?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type createTeamsVerificationKeyMutationVariables = {|
  input: CreateTeamsVerificationKeyInput
|};
export type createTeamsVerificationKeyMutationResponse = {|
  +createTeamsVerificationKey: ?{|
    +key: ?string
  |}
|};
export type createTeamsVerificationKeyMutation = {|
  variables: createTeamsVerificationKeyMutationVariables,
  response: createTeamsVerificationKeyMutationResponse,
|};
*/


/*
mutation createTeamsVerificationKeyMutation(
  $input: CreateTeamsVerificationKeyInput!
) {
  createTeamsVerificationKey(input: $input) {
    key
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateTeamsVerificationKeyInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateTeamsVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createTeamsVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createTeamsVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createTeamsVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createTeamsVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createTeamsVerificationKeyMutation(\n  $input: CreateTeamsVerificationKeyInput!\n) {\n  createTeamsVerificationKey(input: $input) {\n    key\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'be4d14e2aaec5b65a72e8d19e450b866';

module.exports = node;
